<template>
  <div v-if="produit">
    <div class="entete">
        <div class="level">
          <div class="level-left">
            <div class="columns is-gapless">
              <div class="column">
                <h1 class="title is-size-3">
                  {{ getTitle }}
                  <b-tag v-if="!produit.actif && productId"
                    type="has-background-subMenu"
                    class="has-text-white mgl-5px">
                    {{$t('catalogue.etatProduit')}}
                  </b-tag>
                </h1>
                <app-breadcrumb :breadcrumb="breadcrumb" />
              </div>
            </div>
          </div>
          <div class="level-right is-align-self-flex-start">
            <div class="is-pulled-right buttons boutonAction">
            <button @click="$router.go(-1)"
               class="button btn-modal-annuler is-cancel ">
              {{ $t('general.button.cancel') }}
            </button>
            <button class="button is-addOrEdit "
                    @click="insertProduitLocation" :class="[{'button-access-no-permission' :
            produitLocFromHolding},
            { 'pointer-events-none' : produitLocFromHolding }]">
              {{ $t('general.button.sauvegarder') }}
            </button>
            <piece-jointe-button
              class="mgr-2"
              :perm="constantes.CATALOGUE.maj">
            </piece-jointe-button>
            </div>
          </div>
        </div>
        <error-msg-component :messages="messages"
                             :error="error"
                             :messagesChampsVide="messagesChampsVide"
                             :champsVide="champsVide"
                             :title="'editionClient.problemOccurred'"
                             :withEmplyFields="true"
                             @close="error = $event"/>
      <div class="tab">
        <ul>
          <li :class="{'is-active': activeTab === 'produit'}"
              @click="toggleActiveTab('produit')">
            {{ $t('catalogue.newProduct.tab.product') }}
          </li>
          <li :class="{'is-active': activeTab === 'produits-associes'}"
              @click="toggleActiveTab('produits-associes')">
            {{ $t('catalogue.newProduct.tab.products') }}
          </li>
          <li :class="{'is-active': activeTab === 'demandeInterventionType'}"
              @click="activeTab = 'demandeInterventionType'">
            {{ $t('catalogue.newProduct.tab.demandeInterventionType') }}
          </li>
        </ul>
      </div>
    </div>
    <div>
      <keep-alive v-if="produit">
        <component
          :is="activeTab"
          :breadcrumb="breadcrumb"
          :produit="produit"
          :materiel="null"
          :produit-details="produit.produitLocation"
          :sens="getSens"
          :isDisabled="false"
          :permissions="constantes.CATALOGUE"/>
      </keep-alive>
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import cloneDeep from 'lodash/cloneDeep';
import AppBreadcrumb from '@/components/general/breadcrumb';
import inProgress from '@/services/general/inProgress';
import Produit from '@/components/catalogue/produitGeneral/m_produit';
import ProduitsAssocies from '@/components/catalogue/produitGeneral/l_produitsAssocies';
import genererProduitLocation from '@/services/catalogue/genererProduitLocation';
import { create, update, get } from '@/api/produit/produitLocation';
import messageSucces from '@/services/general/messageSucces';
import messageErreur from '@/services/general/messageErreur';
import validationGeneral from '@/services/validation/validation';
import validationProduit from '@/services/catalogue/validation/validationProduit';
import translate from '@/services/catalogue/validation/champsProduitTranslator';
import errorMsgComponent from '@/components/general/errorMsgComponent';
import { SENS_VENTE, SENS_ACHAT } from '@/configuration/devisConf';
import { getIdSocieteHolding, siteHasHolding } from '@/services/general/holding';
import pieceJointeButton from '@/components/general/button/pieceJointeButton';
import { CATALOGUE } from '@/configuration/permissionsBodacConf';
import demandeInterventionType from '@/components/catalogue/produitGeneral/demandeInterventionType/demandeInterventionType';
import { formatProduitBeforeSave } from '@/services/catalogue/formatProduit';

const Attachments = createNamespacedHelpers('attachments');
const ProduitStore = createNamespacedHelpers('produit');
const Societe = createNamespacedHelpers('societe');

export default {
  data: () => ({
    activeTab: 'produit',
    produit: null,
    error: false,
    messages: [],
    messagesChampsVide: [],
    champsVide: [],
    libelle: '',
    constantes: {
      CATALOGUE,
    },
  }),
  components: {
    AppBreadcrumb,
    Produit,
    ProduitsAssocies,
    errorMsgComponent,
    pieceJointeButton,
    demandeInterventionType,
  },
  computed: {
    ...Societe.mapGetters({
      societeActiveId: 'societeActiveId',
    }),
    ...ProduitStore.mapGetters({
      produitReseau: 'produit',
    }),
    produitLocFromHolding() {
      return (siteHasHolding() && this.produit
        && (this.societeActiveId !== this.produit.supportCommercial.societeId
        || this.produit.supportCommercial.societeId !== getIdSocieteHolding()));
    },
    breadcrumb() {
      if (this.$route.params.isFromCatalogueAchat) {
        return [
          { title: this.$i18n.t('catalogue.racine'), route: this.$PAGE_DEFAULT, isActive: false },
          { title: this.$i18n.t('listeProduitAchatLoc.title'), route: { name: 'l.bodac.catalogue-produitAchatLoc' }, isActive: false },
          { title: this.getTitle, route: { name: '' }, isActive: true },
        ];
      }
      return [
        { title: this.$i18n.t('catalogue.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$i18n.t('catalogue.titleProduit'), route: { name: 'l.bodac.catalogue' }, isActive: false },
        { title: this.$i18n.t('catalogue.type.location'), route: { name: 'm.bodac.catalogue-typeCreation' }, isActive: false },
        { title: this.getTitle, route: { name: 'm.bodac.catalogue-nouveauLocation' }, isActive: true },
      ];
    },
    getTitle() {
      return this.productId ? this.$i18n.t('catalogue.editProduct.title',
        { libelle: this.libelle }) : this.$i18n.t('catalogue.newProduct.title');
    },
    productId() {
      return this.$route.params.produitId;
    },
    getSens() {
      return this.$route.params.isFromCatalogueAchat ? SENS_ACHAT : SENS_VENTE;
    },
  },
  beforeRouteEnter(to, from, next) {
    let tab = '';
    switch (from.name) {
      case 'm.bodac.catalogue-ajoutProduitAssocie':
        tab = 'produits-associes';
        break;
      default:
        tab = 'produit';
    }
    next(vm => {
      vm.activeTab = tab;
    });
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      if (this.produitReseau) {
        this.produit = this.produitReseau;
        this.updateProduit(null);
      } else if (!this.productId) {
        this.setInformationPage(this.$t('pageGescom.produit.creationProduitLocation'));
        this.produit = this.$route.params.isFromCatalogueAchat
          ? await genererProduitLocation(false, SENS_ACHAT)
          : await genererProduitLocation(false, SENS_VENTE);
        await this.setAttachmentContext({ module: 'ProduitLocation' });
      } else if (this.productId) {
        await this.setAttachmentContext({ module: 'ProduitLocation' });
        const response = await get(this.productId);
        this.produit = response.data.result;
        this.setInformationPage(this.$t('pageGeneral.modification', { item: this.produit.libelle }));
      }
      if (this.productId) await this.setAttachmentElementId({ id: this.productId });
      this.libelle = cloneDeep(this.produit.libelle);
      loadingComponent.close();
    } catch (e) {
      messageErreur(this.$i18n);
      loadingComponent.close();
      throw e;
    }
  },
  methods: {
    ...Attachments.mapActions({
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      insertAttachments: 'insert',
      updateAttachments: 'update',
    }),
    ...ProduitStore.mapActions({
      updateProduit: 'updateProduit',
    }),
    inProgress(message) {
      inProgress(this.$i18n, message);
    },
    toggleActiveTab(name) {
      this.activeTab = name;
    },

    async insertProduitLocation() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        const produit = formatProduitBeforeSave(this.produit);
        this.champsVide = [];
        this.messagesChampsVide = [];
        this.messages = [];
        this.error = false;
        let produitLocation = {};
        if (this.productId) {
          produitLocation = (await update(produit)).data.result;
          await this.updateAttachments(this.produitId);
          messageSucces(this.$i18n.t('catalogue.updateSuccess'));
        } else {
          produitLocation = (await create(produit)).data.result;
          await this.insertAttachments(produitLocation.id);
          messageSucces(this.$i18n.t('catalogue.addSuccess'));
        }
        loadingComponent.close();
        this.$router.push({ name: 'c.bodac.catalogue-location', params: { id: produitLocation.id, isFromCatalogueAchat: this.$route.params.isFromCatalogueAchat } });
      } catch (e) {
        if (e.response && e.response.data.error) {
          this.error = true;
          this.messages = validationProduit(e.response);
          validationGeneral(this.$i18n, e.response, this.champsVide,
            this.messages, this.messagesChampsVide, translate);
          loadingComponent.close();
          return;
        }
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
};
</script>
